import React from "react";
import "./EmployeeDetails.css";
import { AiOutlineClose } from "react-icons/ai";

function EmployeeDetails({ isOpen, employee, onClose }) {
    if (!isOpen || !employee) return null;

    return (
        <>
            <div className="employee-overlay" onClick={onClose}></div>

            <div className="employee-popup">
                <button className="employee-close-btn" onClick={onClose}>
                    <AiOutlineClose />
                </button>
                <div className="popup-content">
                    <h2>Employee Details</h2>
                    <div className="popup-divider"></div>

                    <div className="employee-info">
                        <p><strong>NIC:</strong> {employee.NIC}</p>
                        <p><strong>First Name:</strong> {employee.FirstName}</p>
                        <p><strong>Last Name:</strong> {employee.LastName}</p>
                        <p><strong>Date of Birth:</strong> {employee.DOB ? new Date(employee.DOB).toISOString().split("T")[0] : "N/A"}</p>
                        <p><strong>Gender:</strong> {employee.Gender}</p>
                        <p><strong>Position:</strong> {employee.Position || "Not Assigned"}</p>
                        {/*<p><strong>Role:</strong> {employee.role_name || "Not Assigned"}</p>*/}
                        {/*<p><strong>Permissions:</strong> {employee.permissions ? employee.permissions.split(',').join(", ") : "No Permissions Assigned"}</p>*/}
                    </div>
                </div>
            </div>
        </>
    );
}

export default EmployeeDetails;
